module.exports = __webpack_public_path__ + "img/sticker-nye-scatbook-en.3f7e9a23.svg";